import { v4 as uuid } from "uuid";
export const message = ({ messageId = uuid(), occurredOn = Date.now(), name, }) => ({
    messageId,
    occurredOn,
    name,
});
